// removed by extract-text-webpack-plugin
module.exports = {"s":"src-components-commons-Pattern-style----size-module---s---3mVaE","m":"src-components-commons-Pattern-style----size-module---m---PPbVl","l":"src-components-commons-Pattern-style----size-module---l---1pVGD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/Pattern/style/size.module.css
// module id = 1428
// module chunks = 168707334958949